import { render } from "./DetailValue.vue?vue&type=template&id=4decdaa5&ts=true"
import script from "./DetailValue.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailValue.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DetailValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4decdaa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4decdaa5', __exports__)) {
    console.log('reload')
    api.reload('4decdaa5', __exports__)
  }
  
  module.hot.accept("./DetailValue.vue?vue&type=template&id=4decdaa5&ts=true", () => {
    console.log('re-render')
    api.rerender('4decdaa5', render)
  })

}


export default __exports__